module.exports = __webpack_public_path__ + "static/media/icon_email.fa508595.png";